import { render, staticRenderFns } from "./setAuditOrder.vue?vue&type=template&id=675a19b4&scoped=true&"
import script from "./setAuditOrder.vue?vue&type=script&lang=js&"
export * from "./setAuditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a19b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675a19b4')) {
      api.createRecord('675a19b4', component.options)
    } else {
      api.reload('675a19b4', component.options)
    }
    module.hot.accept("./setAuditOrder.vue?vue&type=template&id=675a19b4&scoped=true&", function () {
      api.rerender('675a19b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setAuditOrder.vue"
export default component.exports